@if ((isActive$ | async)) {
  <div class="spinner-wrapper"
    role="status"
    aria-live="polite"
    aria-label="Loading content">
    <div class="spinner">
      <div class="spinner-ring" aria-hidden="true">
        <div></div>
        <div></div>
      </div>
    </div>
    <span class="sr-only">Loading...</span>
  </div>
}
